var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_11169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98932 3V2.6C3.98932 1.715 3.98932 1 5.58533 1H6.38334C7.97935 1 7.97935 1.715 7.97935 2.6V3M3.98932 11H7.97935C9.98434 11 10.3434 10.195 10.4482 9.215L10.8222 5.215C10.9569 3.995 10.6078 3 8.4781 3H3.49057C1.3609 3 1.01177 3.995 1.14643 5.215L1.5205 9.215C1.62523 10.195 1.98434 11 3.98932 11Z",
    stroke: "#1E1E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9805 7.01V6.5C6.9805 6 6.9805 6 6.48174 6H5.48424C4.98549 6 4.98549 6 4.98549 6.5V7.015M6.9805 7.01C6.9805 7.555 6.97551 8 5.98299 8C4.99546 8 4.98549 7.56 4.98549 7.015M6.9805 7.01C8.35915 6.83794 9.67183 6.31843 10.796 5.5M4.98549 7.015C3.69371 6.87 2.42688 6.405 1.30469 5.635",
    stroke: "#1E1E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_11169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9701,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.015b210679e8c23f94dfcffc97357e1c.svg";
export { ForwardRef as ReactComponent };